import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule } from '@spartacus/core';
import { GenProductAttributesComponent } from './product-attributes.component';
import { ArraySplitModule } from "../../../../../generac/shared/pipes/array-split/array-split.module";
import { CombineArraysModule } from "../../../../../generac/shared/pipes/combine-arrays/combine-arrays.module";

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ArraySplitModule,
    CombineArraysModule
  ],
  declarations: [GenProductAttributesComponent],
  exports: [GenProductAttributesComponent],
})
export class GenProductAttributesModule {}
